(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-page]').forEach((root) => {
    const messageForms = Array.from(root.querySelectorAll('[data-cart-message-form]'));
    const draftStorageKey = 'anara:cart-messages:' + root.dataset.cartId;
    let messageSaving = false;
    let drafts = {};
    try {
      drafts = JSON.parse(sessionStorage.getItem(draftStorageKey) || '{}');
    } catch {
      drafts = {};
    }

    function storeMessageDrafts() {
      const currentDrafts = {};
      messageForms.forEach((form) => {
        const value = form.querySelector('[data-personalize-input]').value;
        if (value !== form.dataset.savedMessage) currentDrafts[form.dataset.lineKey] = value;
      });
      try {
        sessionStorage.setItem(draftStorageKey, JSON.stringify(currentDrafts));
      } catch {}
    }

    messageForms.forEach((form) => {
      const input = form.querySelector('[data-personalize-input]');
      const saveButton = form.querySelector('[type="submit"]');
      const error = form.querySelector('[data-message-error]');
      const unsaved = form.querySelector('[data-message-unsaved]');
      if (typeof drafts?.[form.dataset.lineKey] === 'string') {
        input.value = drafts[form.dataset.lineKey];
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
      input.addEventListener('input', () => {
        error.hidden = true;
        unsaved.hidden = true;
        storeMessageDrafts();
      });
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (messageSaving) return;
        input.setCustomValidity(input.value.trim() ? '' : input.dataset.requiredMessage);
        if (!form.reportValidity()) return;
        const data = new FormData(form);
        const properties = {};
        for (const [name, value] of data) {
          if (name.startsWith('properties[')) properties[name.slice(11, -1)] = value;
        }
        messageSaving = true;
        saveButton.disabled = true;
        input.readOnly = true;
        error.hidden = true;
        unsaved.hidden = true;
        storeMessageDrafts();
        try {
          const cartRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(cartRoot + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: data.get('id'), quantity: Number(data.get('quantity')), properties }),
          });
          if (!response.ok) throw new Error('Message save failed');
          form.dataset.savedMessage = input.value;
          storeMessageDrafts();
          window.location.reload();
        } catch {
          messageSaving = false;
          saveButton.disabled = false;
          input.readOnly = false;
          error.hidden = false;
        }
      });
    });

    root.addEventListener('click', (event) => {
      if (!messageSaving) return;
      if (event.target.closest('a, button')) event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    function setBusy(el, busy) {
      if (el) el.disabled = busy;
    }

    function changeLine(key, quantity) {
      if (messageSaving) return Promise.resolve();
      storeMessageDrafts();
      const cartRoot = window.Shopify?.routes?.root || '/';
      return fetch(cartRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      }).then(() => window.location.reload());
    }

    root.querySelectorAll('[data-cart-line]').forEach((line) => {
      const key = line.dataset.lineKey;
      const input = line.querySelector('[data-line-quantity]');
      const decreaseBtn = line.querySelector('[data-line-decrease]');
      const increaseBtn = line.querySelector('[data-line-increase]');
      const removeLink = line.querySelector('[data-line-remove]');

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', () => {
          const next = Math.max(0, parseInt(input.value || '1', 10) - 1);
          if (next === 0) return changeLine(key, 0);
          setBusy(decreaseBtn, true);
          changeLine(key, next);
        });
      }

      if (increaseBtn) {
        increaseBtn.addEventListener('click', () => {
          const next = parseInt(input.value || '1', 10) + 1;
          setBusy(increaseBtn, true);
          changeLine(key, next);
        });
      }

      if (input) {
        input.addEventListener('change', () => {
          const next = Math.max(0, parseInt(input.value || '1', 10));
          changeLine(key, next);
        });
      }

      if (removeLink) {
        removeLink.addEventListener('click', (event) => {
          event.preventDefault();
          changeLine(key, 0);
        });
      }
    });

    const discountInput = root.querySelector('[data-discount-input]');
    const discountApply = root.querySelector('[data-discount-apply]');
    const checkoutLink = document.querySelector('[data-checkout-link]');

    if (checkoutLink) {
      checkoutLink.addEventListener('click', (event) => {
        for (const form of messageForms) {
          const input = form.querySelector('[data-personalize-input]');
          input.setCustomValidity(input.value.trim() ? '' : input.dataset.requiredMessage);
          if (!form.reportValidity()) {
            event.preventDefault();
            return;
          }
          if (input.value !== form.dataset.savedMessage) {
            event.preventDefault();
            form.querySelector('[data-message-unsaved]').hidden = false;
            form.querySelector('[type="submit"]').focus();
            return;
          }
        }
      });
    }

    if (discountApply && discountInput && checkoutLink) {
      const baseHref = checkoutLink.getAttribute('href');
      discountApply.addEventListener('click', () => {
        const code = discountInput.value.trim();
        checkoutLink.setAttribute('href', code ? baseHref + '?discount=' + encodeURIComponent(code) : baseHref);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-header-transparent]').forEach((header) => {
    let revealed = false;
    let scrolled = false;
    let revealTimer = null;

    function notify() {
      document.dispatchEvent(new CustomEvent('anara:reveal', { detail: { revealed, scrolled } }));
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      clearTimeout(revealTimer);
      header.classList.add('is-revealed');
      notify();
    }

    function updateScrolled() {
      const isScrolled = window.scrollY > 140;
      if (isScrolled && !revealed) reveal();
      if (isScrolled !== scrolled) {
        scrolled = isScrolled;
        header.classList.toggle('is-scrolled', scrolled);
        notify();
      }
    }

    window.addEventListener('scroll', updateScrolled, { passive: true });
    ['pointerdown', 'keydown', 'wheel', 'touchmove'].forEach((eventName) => {
      window.addEventListener(eventName, reveal, { passive: true, once: true });
    });
    revealTimer = setTimeout(reveal, 8000);

    updateScrolled();
  });

  document.querySelectorAll('[data-drawer]').forEach((drawer) => {
    const openBtn = document.querySelector('[data-drawer-open]');
    const closeEls = drawer.querySelectorAll('[data-drawer-close]');
    const links = drawer.querySelectorAll('.header__drawer-link');

    function openDrawer() {
      drawer.hidden = false;
    }

    function closeDrawer() {
      drawer.hidden = true;
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    closeEls.forEach((el) => el.addEventListener('click', closeDrawer));
    links.forEach((link) => link.addEventListener('click', closeDrawer));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heading-cta-split"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('anara:variant-change', (event) => {
    const variant = event.detail;
    if (!variant) return;

    document.querySelectorAll('[data-heading-cta-sync]').forEach((section) => {
      if (variant.title2) {
        const headingEl = section.querySelector('[data-sync-heading]');
        if (headingEl) headingEl.textContent = variant.title2;
      }
      if (variant.detailsHtml) {
        const bodyEl = section.querySelector('[data-sync-body]');
        if (bodyEl) bodyEl.innerHTML = variant.detailsHtml;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-track-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const message = form.parentElement.querySelector('[data-track-message]');
      if (message) message.hidden = false;
      form.reset();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero]').forEach((hero) => {
    document.addEventListener('anara:reveal', (event) => {
      hero.classList.toggle('is-revealed', event.detail.revealed);
    });

    const dots = hero.querySelectorAll('.hero__dot');
    const slides = hero.querySelectorAll('.hero__slide');
    const captions = hero.querySelectorAll('.hero__caption');
    if (slides.length < 2) return;

    let currentIndex = 0;

    function activateSlide(index) {
      currentIndex = index;
      slides.forEach((slide) => {
        slide.classList.toggle('is-active', slide.dataset.index === String(index));
      });
      dots.forEach((dot) => {
        dot.classList.toggle('is-active', dot.dataset.index === String(index));
      });
      captions.forEach((caption) => {
        caption.classList.toggle('is-active', caption.dataset.index === String(index));
      });
    }

    let timer = null;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!prefersReducedMotion) {
      timer = setInterval(() => {
        activateSlide((currentIndex + 1) % slides.length);
      }, 6000);
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        if (timer) clearInterval(timer);
        activateSlide(parseInt(dot.dataset.index, 10));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('anara:variant-change', (event) => {
    const variant = event.detail;
    if (!variant || !variant.sizesText) return;

    document.querySelectorAll('[data-variant-size-content]').forEach((el) => {
      el.textContent = variant.sizesText;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-addon"]) return;
  try {
    
  document.querySelectorAll('[data-product-addon]').forEach((root) => {
    const dataEl = root.querySelector('[data-product-addon-json]');
    if (!dataEl) return;

    let data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const variants = data.variants || [];
    const idInput = root.querySelector('[data-variant-id-input]');
    const priceEl = root.querySelector('[data-price-value]');
    const submitBtn = root.querySelector('[data-add-to-cart]');
    const specsEl = root.querySelector('[data-specs]');

    const selected = {};
    root.querySelectorAll('[data-option-index].is-active').forEach((btn) => {
      selected[btn.dataset.optionIndex] = btn.dataset.optionValue;
    });

    let currentVariant = variants.find((variant) => idInput && variant.id === parseInt(idInput.value, 10));

    function formatMoney(cents, format) {
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision === undefined ? 2 : precision;
        thousands = thousands === undefined ? ',' : thousands;
        decimal = decimal === undefined ? '.' : decimal;
        if (isNaN(number) || number == null) return 0;
        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsPart = parts[1] ? decimal + parts[1] : '';
        return dollars + centsPart;
      }

      if (!format) return '';

      const openTag = String.fromCharCode(123, 123);
      const closeTag = String.fromCharCode(125, 125);
      const start = format.indexOf(openTag);
      const end = format.indexOf(closeTag);
      if (start === -1 || end === -1) return format;

      const token = format.slice(start + openTag.length, end).replace(/^\s+|\s+$/g, '');

      let value;
      switch (token) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return format.slice(0, start) + value + format.slice(end + closeTag.length);
    }

    function updateSubmitLabel() {
      if (!submitBtn || !currentVariant || !currentVariant.available) return;
      const template = submitBtn.dataset.priceTemplate;
      if (!template) return;

      const qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
      const total = formatMoney(currentVariant.price * qty, data.moneyFormat);
      submitBtn.textContent = template.replace('__PRICE__', total);
    }

    function findVariant() {
      return variants.find((variant) =>
        variant.options.every((value, index) => selected[index + 1] === undefined || selected[index + 1] === value)
      );
    }

    function updateSpecs(variant) {
      if (!specsEl) return;
      specsEl.innerHTML = '';
      (variant.specs || []).forEach((item) => {
        const row = document.createElement('div');
        row.className = 'product-addon__spec';

        const labelEl = document.createElement('span');
        labelEl.textContent = item.label;
        const valueEl = document.createElement('span');
        valueEl.textContent = item.value;

        row.appendChild(labelEl);
        row.appendChild(valueEl);
        specsEl.appendChild(row);
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      currentVariant = variant;

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.priceFormatted;
      if (submitBtn) submitBtn.disabled = !variant.available;

      updateSpecs(variant);
      root.querySelector('[data-personalize]')?.dispatchEvent(new CustomEvent('personalization:change', { detail: variant.personalization }));
      updateSubmitLabel();

      document.dispatchEvent(new CustomEvent('anara:variant-change', { detail: variant }));
    }

    root.querySelectorAll('[data-option-index]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const index = btn.dataset.optionIndex;
        selected[index] = btn.dataset.optionValue;

        root.querySelectorAll('[data-option-index="' + index + '"]').forEach((sibling) => {
          sibling.classList.toggle('is-active', sibling === btn);
        });

        applyVariant(findVariant());
      });
    });

    const qtyInput = root.querySelector('[data-quantity-input]');
    const decreaseBtn = root.querySelector('[data-quantity-decrease]');
    const increaseBtn = root.querySelector('[data-quantity-increase]');

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', () => {
        if (!qtyInput) return;
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
        updateSubmitLabel();
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener('click', () => {
        if (!qtyInput) return;
        qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
        updateSubmitLabel();
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', updateSubmitLabel);
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gift-card"]) return;
  try {
    
  document.querySelectorAll('[data-gift-card-buy]').forEach((root) => {
    const formatEl = root.querySelector('[data-gift-card-money-format]');
    let moneyFormat = '';
    try {
      moneyFormat = formatEl ? JSON.parse(formatEl.textContent) : '';
    } catch (e) {}

    const submitBtn = root.querySelector('[data-add-to-cart]');
    const qtyInput = root.querySelector('[data-quantity-input]');
    const decreaseBtn = root.querySelector('[data-quantity-decrease]');
    const increaseBtn = root.querySelector('[data-quantity-increase]');

    function formatMoney(cents, format) {
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision === undefined ? 2 : precision;
        thousands = thousands === undefined ? ',' : thousands;
        decimal = decimal === undefined ? '.' : decimal;
        if (isNaN(number) || number == null) return 0;
        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsPart = parts[1] ? decimal + parts[1] : '';
        return dollars + centsPart;
      }

      if (!format) return '';

      const openTag = String.fromCharCode(123, 123);
      const closeTag = String.fromCharCode(125, 125);
      const start = format.indexOf(openTag);
      const end = format.indexOf(closeTag);
      if (start === -1 || end === -1) return format;

      const token = format.slice(start + openTag.length, end).replace(/^\s+|\s+$/g, '');

      let value;
      switch (token) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return format.slice(0, start) + value + format.slice(end + closeTag.length);
    }

    function updateSubmitLabel() {
      if (!submitBtn) return;
      const template = submitBtn.dataset.priceTemplate;
      const unitPrice = parseInt(submitBtn.dataset.variantPrice || '0', 10);
      if (!template) return;

      const qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
      const total = formatMoney(unitPrice * qty, moneyFormat);
      submitBtn.textContent = template.replace('__PRICE__', total);
    }

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', () => {
        if (!qtyInput) return;
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
        updateSubmitLabel();
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener('click', () => {
        if (!qtyInput) return;
        qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
        updateSubmitLabel();
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', updateSubmitLabel);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function formatMoney(cents, format) {
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    if (!format) return '';

    const openTag = String.fromCharCode(123, 123);
    const closeTag = String.fromCharCode(125, 125);
    const start = format.indexOf(openTag);
    const end = format.indexOf(closeTag);
    if (start === -1 || end === -1) return format;

    const token = format.slice(start + openTag.length, end).replace(/^\s+|\s+$/g, '');

    let value;
    switch (token) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.slice(0, start) + value + format.slice(end + closeTag.length);
  }

  document.querySelectorAll('[data-product-hero]').forEach((root) => {
    const dataEl = root.querySelector('[data-product-hero-json]');
    if (!dataEl) return;

    let data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const variants = data.variants || [];
    const idInput = root.querySelector('[data-variant-id-input]');
    const submitBtn = root.querySelector('[data-add-to-cart]');
    const shotsNav = root.querySelector('[data-shots-nav]');

    const selected = {};
    root.querySelectorAll('[data-option-index].is-active').forEach((btn) => {
      selected[btn.dataset.optionIndex] = btn.dataset.optionValue;
    });

    let currentVariant = variants.find((variant) => idInput && variant.id === parseInt(idInput.value, 10));

    function updateSubmitLabel() {
      if (!submitBtn || !currentVariant || !currentVariant.available) return;
      const template = submitBtn.dataset.priceTemplate;
      if (!template) return;

      const qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
      const total = formatMoney(currentVariant.price * qty, data.moneyFormat);
      submitBtn.textContent = template.replace('__PRICE__', total);
    }

    function findVariant() {
      return variants.find((variant) =>
        variant.options.every((value, index) => selected[index + 1] === undefined || selected[index + 1] === value)
      );
    }

    const media = root.querySelector('.product-hero__media');
    const viewToggle = root.querySelector('[data-view-toggle]');
    const viewToggleLabel = root.querySelector('[data-view-toggle-label]');
    const shotsGrid = root.querySelector('[data-shots-grid]');

    function setGridView(isGrid) {
      if (!media) return;
      media.classList.toggle('is-grid', isGrid);
      if (!viewToggle) return;
      viewToggle.setAttribute('aria-pressed', String(isGrid));
      if (viewToggleLabel) {
        viewToggleLabel.textContent = isGrid ? viewToggle.dataset.labelSingle : viewToggle.dataset.labelGrid;
      }
    }

    function showVariantMedia(variantId) {
      root.querySelectorAll('.product-hero__thumbs-group, .product-hero__grid-group').forEach((group) => {
        group.classList.toggle('is-active-group', group.dataset.variantId === String(variantId));
      });

      const hasGallery = !!root.querySelector('.product-hero__thumbs-group[data-variant-id="' + variantId + '"]');
      if (viewToggle) viewToggle.hidden = !hasGallery;
      if (!hasGallery) setGridView(false);

      setActiveShot(variantId, 0);
    }

    function setActiveShot(variantId, shotIndex) {
      root.querySelectorAll('.product-hero__image[data-variant-id]').forEach((img) => {
        const isCurrent = img.dataset.variantId === String(variantId);
        img.classList.toggle('is-active', isCurrent && img.dataset.shotIndex === String(shotIndex));
      });

      root.querySelectorAll('.product-hero__thumbs-group[data-variant-id="' + variantId + '"] .product-hero__thumb').forEach((thumb) => {
        const isActive = thumb.dataset.shotIndex === String(shotIndex);
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', String(isActive));
      });
    }

    if (shotsNav) {
      shotsNav.addEventListener('click', (event) => {
        const thumb = event.target.closest('.product-hero__thumb');
        if (!thumb) return;
        const group = thumb.closest('.product-hero__thumbs-group');
        if (!group) return;
        setActiveShot(group.dataset.variantId, thumb.dataset.shotIndex);
      });
    }

    if (shotsGrid) {
      shotsGrid.addEventListener('click', (event) => {
        const item = event.target.closest('.product-hero__grid-item');
        if (!item) return;
        const group = item.closest('.product-hero__grid-group');
        if (!group) return;
        setActiveShot(group.dataset.variantId, item.dataset.shotIndex);
        setGridView(false);
      });
    }

    if (viewToggle) {
      viewToggle.addEventListener('click', () => {
        setGridView(!media.classList.contains('is-grid'));
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      currentVariant = variant;

      if (idInput) idInput.value = variant.id;
      if (submitBtn) submitBtn.disabled = !variant.available;

      root.querySelector('[data-personalize]')?.dispatchEvent(new CustomEvent('personalization:change', { detail: variant.personalization }));
      showVariantMedia(variant.id);
      updateSubmitLabel();

      document.dispatchEvent(new CustomEvent('anara:variant-change', { detail: variant }));
    }

    root.querySelectorAll('[data-option-index]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const index = btn.dataset.optionIndex;
        selected[index] = btn.dataset.optionValue;

        root.querySelectorAll('[data-option-index="' + index + '"]').forEach((sibling) => {
          sibling.classList.toggle('is-active', sibling === btn);
          sibling.setAttribute('aria-pressed', String(sibling === btn));
        });

        const labelEl = root.querySelector('[data-selected-value-label="' + index + '"]');
        if (labelEl) labelEl.textContent = btn.dataset.optionValue;

        applyVariant(findVariant());
      });
    });

    const qtyInput = root.querySelector('[data-quantity-input]');
    const decreaseBtn = root.querySelector('[data-quantity-decrease]');
    const increaseBtn = root.querySelector('[data-quantity-increase]');

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', () => {
        if (!qtyInput) return;
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
        updateSubmitLabel();
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener('click', () => {
        if (!qtyInput) return;
        qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
        updateSubmitLabel();
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', updateSubmitLabel);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const sections = document.querySelectorAll('.testimonials');
    if (!sections.length) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      sections.forEach((section) => {
        const r = section.getBoundingClientRect();
        const p = Math.max(0, Math.min(1, (window.innerHeight - r.top) / (window.innerHeight + r.height)));
        section.style.setProperty('--testimonials-pattern-y', `${(p - 0.5) * -180}px`);
      });
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();
})();
